// extracted by mini-css-extract-plugin
export var inputContainer = "_o1-0";